const THAI_COMBINING_MARKS = /[\u0E31\u0E34-\u0E3A\u0E47-\u0E4E]/g;
const INVISIBLE_MARKS = /[\u200B-\u200D\u2060\uFEFF]/g;

export function normalizeSearchText(value, { stripThaiMarks = false } = {}) {
  let text = String(value ?? '')
    .normalize('NFKC')
    .replace(INVISIBLE_MARKS, '')
    .toLocaleLowerCase('th-TH')
    .replace(/\s+/g, ' ')
    .trim();
  if (stripThaiMarks) text = text.replace(THAI_COMBINING_MARKS, '');
  return text;
}

export function matchesSearch(value, query) {
  const needle = normalizeSearchText(query);
  if (!needle) return true;
  const haystack = normalizeSearchText(value);
  if (haystack.includes(needle)) return true;
  const looseNeedle = normalizeSearchText(query, { stripThaiMarks: true });
  if (!looseNeedle) return false;
  return normalizeSearchText(value, { stripThaiMarks: true }).includes(looseNeedle);
}

export function matchesAnySearch(values, query) {
  return values.some(value => matchesSearch(value, query));
}
